// extracted by mini-css-extract-plugin
module.exports = {"blogArticleNavigation__wrapper":"BlogArticleNavigation_blogArticleNavigation__wrapper__Ul_kU","blogArticleNavigation":"BlogArticleNavigation_blogArticleNavigation__dsMDd"};